module.exports = __webpack_public_path__ + "222b6022da3e72772138f8351b5170bf.svg";